import * as airtable from './airtable';
import * as asana from './asana';
import * as aws_s3 from './aws-s3';
import * as discord from './discord';
import * as dropbox from './dropbox';
import * as github from './github';
import * as gitlab from './gitlab';
import * as gmail from './gmail';
import * as google_calendar from './google-calendar';
import * as google_docs from './google-docs';
import * as google_drive from './google-drive';
import * as google_sheets from './google-sheets';
import * as hubspot from './hubspot';
import * as jira from './jira';
import * as linear from './linear';
import * as microsoft_entra from './microsoft-entra';
import * as microsoft_onedrive from './microsoft-onedrive';
import * as microsoft_outlook from './microsoft-outlook';
import * as microsoft_sharepoint from './microsoft-sharepoint';
import * as microsoft_teams from './microsoft-teams';
import * as notion from './notion';
import * as paypal from './paypal';
import * as salesforce from './salesforce';
import * as sendgrid from './sendgrid';
import * as slack from './slack';
import * as smtp_email from './smtp-email';
import * as stripe from './stripe';
import * as trello from './trello';
import * as twilio from './twilio';

export const integrationsNodes = {
  'airtable': airtable,
  'asana': asana,
  'aws-s3': aws_s3,
  'discord': discord,
  'dropbox': dropbox,
  'github': github,
  'gitlab': gitlab,
  'gmail': gmail,
  'google-calendar': google_calendar,
  'google-docs': google_docs,
  'google-drive': google_drive,
  'google-sheets': google_sheets,
  'hubspot': hubspot,
  'jira': jira,
  'linear': linear,
  'microsoft-entra': microsoft_entra,
  'microsoft-onedrive': microsoft_onedrive,
  'microsoft-outlook': microsoft_outlook,
  'microsoft-sharepoint': microsoft_sharepoint,
  'microsoft-teams': microsoft_teams,
  'notion': notion,
  'paypal': paypal,
  'salesforce': salesforce,
  'sendgrid': sendgrid,
  'slack': slack,
  'smtp-email': smtp_email,
  'stripe': stripe,
  'trello': trello,
  'twilio': twilio,
};
